import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchLogin } from "../Actions/userAction";
import Form from "../components/Layout/Form/index";

const schema = yup.object().shape({
    email: yup.string().required().email(),
    password: yup.string().min(3).required(),
});

export default function Login() {
    const { Error,isLogin } = useSelector((state) => state.user);
    const history = useHistory();
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onsubmit = (data) => {
        dispatch(fetchLogin(data));
    };


  useEffect(()=>{
    if(isLogin){
       history.push("/")
    }
  },[isLogin])

    

    return (
        <>
            <Form
                register={register}
                handleSubmit={handleSubmit}
                onsubmit={onsubmit}
                error={Error}
                errors={errors}
                create={false}
                title={"Login"}
            />
        </>
    );
}
